import axios, { AxiosError } from 'axios';
import { Api} from '../axioscadastro';

interface IAuth {
  accessToken: string;
}
export interface IUsuarios {
  login: string;
  senha: string;
}
type BackendError = {
  errors?: {
    default?: string;
  };
};
const auth = async (login: string, senha: string): Promise<IAuth> => {
  try {
    const { data } = await Api.post<IAuth>('/login', { login, senha });
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<BackendError>;

      const message =
        axiosError.response?.data?.errors?.default ||
        'Erro ao autenticar. Tente novamente.';

      throw new Error(message);
    }

    throw new Error('Erro inesperado');
  }
};

export const AuthService = {
  auth,
};
